'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utils = {
  EMPTY_STRING_REGEXP: /^\s*$/,

  isString: function isString(value) {
    return typeof value === 'string';
  },
  isArray: function isArray(value) {
    return {}.toString.call(value) === '[object Array]';
  },


  // Checks if the value is a number. This function does not consider NaN a
  // number like many other `isNumber` functions do.
  isNumber: function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  },


  // Returns false if the object is not a function
  isFunction: function isFunction(value) {
    return typeof value === 'function';
  },


  // A simple check to verify that the value is an integer. Uses `isNumber`
  // and a simple modulo check.
  isInteger: function isInteger(value) {
    return this.isNumber(value) && value % 1 === 0;
  },


  // Checks if the value is a boolean
  isBoolean: function isBoolean(value) {
    return typeof value === 'boolean';
  },


  // Uses the `Object` function to check if the given argument is an object.
  isObject: function isObject(obj) {
    return obj === Object(obj);
  },


  // Simply checks if the object is an instance of a date
  isDate: function isDate(obj) {
    return obj instanceof Date;
  },


  // Simply checks if the object is an instance of a moment
  isMoment: function isMoment(obj) {
    return obj instanceof _moment2.default;
  },


  // Returns false if the object is `null` of `undefined`
  isDefined: function isDefined(obj) {
    return obj !== null && obj !== undefined;
  },


  // Checks if the given argument is a promise. Anything with a `then`
  // function is considered a promise.
  isPromise: function isPromise(p) {
    return !!p && this.isFunction(p.then);
  },
  isDomElement: function isDomElement(o) {
    if (!o) {
      return false;
    }

    if (!o.querySelectorAll || !o.querySelector) {
      return false;
    }

    if (this.isObject(document) && o === document) {
      return true;
    }

    // http://stackoverflow.com/a/384380/699304
    /* istanbul ignore else */
    if ((typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object') {
      return o instanceof HTMLElement;
    }
    return o && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string';
  },
  isEmpty: function isEmpty(value) {
    var attr = void 0;

    // Null and undefined are empty
    if (!this.isDefined(value)) {
      return true;
    }

    // functions are non empty
    if (this.isFunction(value)) {
      return false;
    }

    // Whitespace only strings are empty
    if (this.isString(value)) {
      return this.EMPTY_STRING_REGEXP.test(value);
    }

    // For arrays we use the length property
    if (this.isArray(value)) {
      return value.length === 0;
    }

    // Dates have no attributes but aren't empty
    if (this.isDate(value)) {
      return false;
    }

    // If we find at least one property we consider it non empty
    if (this.isObject(value)) {
      for (attr in value) {
        return false;
      }
      return true;
    }

    return false;
  },


  // Checks if the object is a hash, which is equivalent to an object that
  // is neither an array nor a function.
  isHash: function isHash(value) {
    return this.isObject(value) && !this.isArray(value) && !this.isFunction(value);
  },
  contains: function contains(obj, value) {
    if (!this.isDefined(obj)) {
      return false;
    }
    if (this.isArray(obj)) {
      return obj.indexOf(value) !== -1;
    }
    return value in obj;
  },
  unique: function unique(array) {
    if (!this.isArray(array)) {
      return array;
    }
    return array.filter(function (el, index, array) {
      return array.indexOf(el) === index;
    });
  },
  resolveAttribute: function resolveAttribute(attribute) {
    var path = [];

    if (typeof attribute === 'string') {
      var slugs = attribute.split('.');

      slugs.forEach(function (slug) {
        var match = /([a-zA-Z_0-9]+)/g.exec(slug);

        if (!match) {
          throw new Error('resolveAttribute - given attribute has a bad format.');
        }

        path.push(match[0]);

        var regExp = /\[(\d+)]/g;

        while (match = regExp.exec(slug)) {
          path.push(+match[1]);
        }
      });
    } else {
      throw new Error('resolveAttribute - attribute must be a string.');
    }

    return path;
  }
};

exports.default = utils;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/utils.js
// module id = 25
// module chunks = 0